<template>
  <div class="child">
    <div class="chart-box" :id="indexId+indexName"></div>
    <img
      class="lock fade-in-right"
      v-if="powerYn=='N' && done"
      @click="clickLock"
      src="../../assets/img/lock.png"
      alt
    />
    <div class="no-data" v-if="!lineData.length">暂无数据</div>
  </div>
</template>

<script>
import { findIndexData } from "@/api/product";
import { mapState } from "vuex";
export default {
  props: ["indexId", "indexName", "noShadow"],
  data() {
    return {
      lineData: [],
      done: false,
      powerYn: "N"
    };
  },
  computed: {
    ...mapState(["authorization"])
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.handleFindIndexData();
    });
  },
  methods: {
    async handleFindIndexData() {
      let { data } = await findIndexData({
        id: this.indexId
      });
      this.powerYn = data.resultBody.powerYn;
      this.lineData = data.resultBody.list;
      this.drawLine(data.resultBody.list);
    },
    drawLine(data) {
      if (data && !data.length) {
        return;
      }
      let xData = [],
        yData = [];
      data.forEach(i => {
        xData.push(i.date);
        yData.push(i.value);
      });
      let chartDom = document.getElementById(this.indexId + this.indexName);
      let myChart = this.$echarts.init(chartDom);
      myChart.clear();
      let option;
      option = {
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [...new Set(xData)].sort(),
          id: "overlinexAxis",
          position: "bottom",
          axisLabel: {
            interval: 10000,
            showMinLabel: true,
            showMaxLabel: true,
            fontSize: 10
          },
          axisLine: {
            //x轴轴线
            lineStyle: {
              color: "#808080",
              width: 0.5,
              type: "solid"
            }
          },
          axisTick: {
            show: false,
            alignWithLabel: true,
            inside: true
          },
          splitLine: {
            show: false
          },
          splitArea: {
            show: false
          }
        },
        grid: {
          containLabel: true,
          bottom: "4%",
          left: "4%",
          right: "12%",
          top: "4%"
        },
        yAxis: {
          type: "value",
          nameGap: 10,
          scale: true,
          splitNumber: 1,
          boundaryGap: true,
          axisLabel: {
            margin: 12,
            color: "#999",
            fontFamily: "arial",
            fontSize: 10
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(160,160,160,.1)",
              type: "solid"
            }
          },
          axisTick: {
            onGap: false,
            show: false
          },
          splitArea: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(160,160,160,.1)"
            }
          },
          axisPointer: {
            show: false
          }
        },
        series: [
          {
            data: yData,
            type: "line",
            itemStyle: {
              normal: {
                color: this.noShadow ? "#e0393a" : "#f47f37",
                lineStyle: {
                  color: this.noShadow ? "#e0393a" : "#f47f37",
                  width: 1
                }
              }
            },
            areaStyle: {
              color: "rgba(193,85,53,0.3)"
            },
            smooth: true,
            symbol: "none"
          }
        ]
      };
      if (this.noShadow) {
        delete option.series[0].areaStyle;
      }
      option && myChart.setOption(option);
      setTimeout(() => {
        this.done = true;
      }, 1000);
    },
    clickLock() {
      this.$emit("showDialog", 1);
    }
  }
};
</script>
<style lang="scss" scoped>
.child {
  height: 100%;
  box-sizing: border-box;
  position: relative;
  .lock {
    position: absolute;
    right: 0;
    bottom: 34px;
    height: 100px;
    width: auto;
    transition: ease-in-out 0.1s;
  }
  .chart-box {
    height: 100%;
    padding: 10px;
    box-sizing: border-box;
  }
  .no-data {
    position: absolute;
    left: 40%;
    top: 45%;
    font-size: 14px;
  }
  @keyframes fade-in-right {
    0% {
      transform: translateX(50px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  .fade-in-right {
    animation: fade-in-right 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  }
}
</style>